import { device } from 'commons';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  gap: 16px;

  @media (max-width: ${device.desktopSmall}px) {
    flex-direction: column;
  }
`;

export const Card = styled.div<{ $isFigureCard?: boolean }>`
  min-height: 96px;
  display: flex;
  align-items: center;
  flex: 1;
  gap: 16px;
  border-radius: 8px;
  background-color: ${({ $isFigureCard, theme }) =>
    $isFigureCard ? theme.primary_300 : theme.primary_200};
  padding: 0 16px;
  position: relative;
  overflow: hidden;
  ${({ $isFigureCard, theme }) =>
    $isFigureCard && `color: ${theme.neutral_100}`}
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  min-width: 64px;
  min-height: 64px;
  border-radius: 64px;
  background-color: ${({ theme }) => theme.neutral_100};

  svg {
    width: 32px;
    height: 32px;
  }
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FigureWrapper = styled(DescriptionWrapper)`
  position: absolute;
  right: -1px;
`;

export const Description = styled.div`
  display: flex;
  gap: 4px;

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 16px;
      height: 16px;
    }
  }
`;

export const ValueWrapper = styled.div<{ $positive?: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${({ $positive, theme }) =>
    $positive ? theme.success_300 : theme.neutral_500};
`;

export const SkeletonCard = styled.div`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  width: 100%;
  height: 96px;
  border-radius: 8px;

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;
